// テーブル管理
import commonGridClass from "./commonGridClass";
// import { Record } from "immutable";

// ステータスの選択肢
var OPTION_STATUS = [
  { text: 'OK', value: '1' },
  { text: '落NG', value: '3' },
  { text: '競合NG', value: '2' },
  { text: '保留', value: '4' },
  { text: '無効リード', value: '5' },
  { text: 'その他', value: '9' }
];

// ステータス(オンラインリード)の選択肢
var OPTION_ONLINELEAD_STATUS = [
  { text: 'OK', value: '1' },
  { text: '競合NG', value: '2' },
  { text: '属NG', value: '3' },
  { text: '保留', value: '4' },
  { text: '無効リード', value: '5' },
  { text: 'その他', value: '9' }
];

// 受講票ステータス
var OPTION_CLIENT_STATUS = [
  { text: 'OK', value: '1' },
  { text: 'NG', value: '2' },
  { text: '保留', value: '3' }
];

// 固定列のヘッダグループ
const INIT_GROUPS = [
  { id: 'readRecordGroup', color: '#ff6633', customizable: false },
  { id: 'customGroup', color: '#F5A623', customizable: true }
];

// 表の固定列データ(登録者リスト)
var FIXED_COLUMN_DATA = [
  { columnType: 'number', field: 'num', group: 'readRecordGroup' },
  { columnType: 'name', field: 'name', group: 'readRecordGroup' },
  { columnType: 'clientStatus', field: 'clientStatus', checked: false, group: 'readRecordGroup' },
  { columnType: 'attend', field: 'attend', checked: false, group: 'readRecordGroup' },
  { columnType: 'sendRequest', field: 'sendRequest', checked: false, group: 'readRecordGroup' },
];

// 表の固定列データ(セミナー登録者リスト)
var FIXED_COLUMN_DATA_SEMINOR = [
  { columnType: 'number', field: 'num', group: 'readRecordGroup' },
  { columnType: 'name', field: 'name', group: 'readRecordGroup' },
  { columnType: 'clientStatus', field: 'clientStatus', checked: false, group: 'readRecordGroup' },
  { columnType: 'attend', field: 'attend', checked: false, group: 'readRecordGroup' },
  { columnType: 'sendRequest', field: 'sendRequest', checked: false, group: 'readRecordGroup' },
];

// 初期表示時の削除行のfield名
const FIELD_INIT_DELETE = '_initdelete';

// 表のID
const GRID_ID = 'grid_dashboard_readrecord';

// カスタム検索のフィルター名
const CUSTOM_FILTER_LABEL = 'customFilter';

export default class dashboardReadRecordGridClass extends commonGridClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }

  // class変数定義
  _classValiableDefine() {
    // 列データ
    this._columnData = [];
    // マスクをかける列
    this._maskedColumn = [];
    // グループ列
    this._columnGroupData = [];
    // 個人情報の編集権限
    this._editable = false;
    // 表のタイプ
    this._type = "readrecord";
    // 提出（マスク提出）の有効フラグ
    this._enableSendRequest = true;

    // フィルタ(行)UI
    this.$filterRecordCheckBox = $('.js-filter-record-mask input');
    this.$filterSubmissionCheckBox = this.$filterRecordCheckBox.filter('.is-submission');
    this.$filterMaskSubmissionCheckBox = this.$filterRecordCheckBox.filter('.is-masksubmission');
    this.$filterDeleteCheckBox = this.$filterRecordCheckBox.filter('.is-delete');
    this.$filterStatusStopCheckBox = this.$filterRecordCheckBox.filter('.is-status-stop');
    this.$filterStatusLeadCheckBox = this.$filterRecordCheckBox.filter('.is-status-lead');
    this.$filterReasonDishonestCheckBox = this.$filterRecordCheckBox.filter('.is-reason-dishonest');

    this.$filterRecordForm = $('.js-filter-record-form');

    // フィルタ(列)UI
    this.$filterColumnCheckBox = $('.js-filter-column');
    this.$filterDeleteColumnCheckBox = this.$filterColumnCheckBox.filter('.is-delete');
    this.$filterPersonalInfoColumnCheckBox = this.$filterColumnCheckBox.filter('.is-personalInfo');
    this.$filterSurveyColumnCheckBox = this.$filterColumnCheckBox.filter('.is-survey');

    // 検索UI
    this.$SearchOpenButton = $('.js-search-open');
    this.$SearchExecuteButton = $('.js-search');
    this.$SearchResetButton = $('.js-reset');

    // 検索(コンテンツ)
    this.$SearchContentListWrap = $('.js-search-contentList-wrapper');
    this.$SearchContentList = $('.js-search-contentList');

    // カスタム列追加UI
    this.$customColumnButton = $('.js-custom');
    this.$customColumnAddButton = $('.js-add-record');
    this.$customColumnContainer = $('.article_custom');
    this.$customColumnName = $('.js-clm_name');
    this.$customColumnNumber = $('.js-clm_num');
    this.$customColumnId = $('.js-clm_id');

    // カスタム列追加テーブル
    this.$customColumnTable = $('.js-custom-table');
    this.$customColumnTableRowWrap = $('.js-custom-row-wrapper');
    this.$customColumnTableRow = $('.js-custom-row');

    // ローディング画面
    this.$loading = $('.js-rcd-loading');

    // エラー表示
    this.$error = $('.js-record-error');
    this.$errorMessage = $('.js-record-error-message');

    // 一括セット機能
    this.$allSetterSelector = $('.js-record-all-setter-selector');
    this.$allSetterTrigger = $('.js-record-all-setter-trigger');
  }

  // 初期化用関数
  _init() {
    const cls = this;

    cls._initFilterColumn();
    cls._initFilterRecord();
  }

  /**
   * カスタム列追加の初期化
   */
  _initCustomColumn() {
    const cls = this;

    // カスタム列追加テーブルを更新
    const refreshTable = () => {
      const sortedCustomColumn = _(cls._columnData)
                                  .filter(data => data.columnType === 'custom')
                                  .sortBy(data => parseInt(data.field.slice(6), 10))
                                  .value();

      cls.$customColumnTableRowWrap.empty();

      sortedCustomColumn.forEach(column => {
        const $customColumnTableRow = cls.$customColumnTableRow.clone();

        $customColumnTableRow.find('.js-custom-id').text(column.field.slice(6));
        $customColumnTableRow.find('.js-custom-name').text(column.label);
        $customColumnTableRow.find('.js-custom-number').text(cls._getColumnIndex(column.field));

        $customColumnTableRow.appendTo(cls.$customColumnTableRowWrap);
      });
    }

    // カスタム列追加インプットの初期化
    const refreshInput = () => {
      cls.$customColumnName.val('');
      cls.$customColumnNumber.val('');

      cls.$customColumnId.text(cls._columnData.filter(data => data.columnType === 'custom').length + 1);
    }

    // カスタム列の追加
    const addCustomColumn = (label, columnNumber,  callback) => {
      // TODO: バリデーションメッセージ
      if (label.length === 0) return;
      if (!columnNumber || columnNumber < 1) return;

      const id = parseInt(cls.$customColumnId.text(), 10);
      const column = {
        label,
        columnType : 'custom',
        group      : 'customGroup',
        field      : `custom${id}`,
        editType   : (cls._editable) ? 'text' : null,
        checked    : false
      };

      // カラムデータの存在チェック
      const existedColumnNumber = _.findIndex(cls._columnData, data => data.field === `custom${id}`);
      let addedColumnNumber = columnNumber;
      if (existedColumnNumber > -1) {
        _.pullAt(cls._columnData, existedColumnNumber);
        addedColumnNumber = (existedColumnNumber < columnNumber) ? --addedColumnNumber : addedColumnNumber;
      }

      // カラムグループがカスタム列追加を非許可している場合は中断
      const currentAfterGroup = _.get(cls._columnData[addedColumnNumber] || cls._columnData[cls._columnData.length - 1], 'group', '');
      const currentBeforeGroup = _.get(cls._columnData[addedColumnNumber - 1] || cls._columnData[0], 'group', '');
      if (!_.get(cls._columnGroupData.find(item => item.id === currentAfterGroup), 'customizable', true)
        && !_.get(cls._columnGroupData.find(item => item.id === currentBeforeGroup), 'customizable', true)) {

        cls._showError('個人情報グループ列に「カスタム列」の追加・移動はできません。挿入位置をご確認の上、再度反映ください。');
        return;
      }

      // カラムデータの挿入
      cls._columnData = [
        ...cls._columnData.slice(0, addedColumnNumber),
        column,
        ...cls._columnData.slice(addedColumnNumber)
      ];

      // カラムの追加・更新
      // TODO: カラム番号を動的に変えるためcolumnに手動追加
      // w2ui[GRID_ID].addColumn(columnNumber, cls._renderColumn(column));
      w2ui[GRID_ID].columns = cls._columnData.map(item => cls._renderColumn(item));
      w2ui[GRID_ID].refresh();

      refreshTable();
      refreshInput();

      cls._dismissError();

      if (typeof callback === 'function') {
        callback();
      }
    }

    // カスタム列追加テーブルの初期化
    cls.$customColumnTableRowWrap.empty();

    // カスタム列追加ボタン
    cls.$customColumnButton.on('click', function() {
      cls.$customColumnContainer.addClass('is-show');
      refreshInput();
    });

    // カスタム列反映ボタン
    cls.$customColumnAddButton.on('click', function() {
      const fixedColumnData = (cls._gridType === "seminor")? FIXED_COLUMN_DATA_SEMINOR : FIXED_COLUMN_DATA;
      const label = cls.$customColumnName.val();
      const number = cls.$customColumnNumber.val();
      const columnNumber = parseInt(number, 10) + fixedColumnData.length - 1;

      // カスタム列の追加
      addCustomColumn(label, columnNumber, function() {
        cls.$customColumnTable.show();
        cls.$customColumnContainer.removeClass('is-show');
      });
    });

    // カスタム列編集ボタン
    $(document).on('click', '.js-custom-id', function() {
      const $this = $(this);
      const $row = $this.closest('.js-custom-row');

      cls.$customColumnContainer.addClass('is-show');

      // 現在の値をインプットに指定
      cls.$customColumnName.val($row.find('.js-custom-name').text());
      cls.$customColumnNumber.val($row.find('.js-custom-number').text());
      cls.$customColumnId.text($this.text());
    });
  }

  /**
   * 列のカスタムフィルタを適用
   */
  customColumnFilter() {
    var cls = this;

    var isShowDelete = cls.$filterDeleteColumnCheckBox.prop('checked');
    var isShowPersonalInfo = cls.$filterPersonalInfoColumnCheckBox.prop('checked');
    var isShowSurvey = cls.$filterSurveyColumnCheckBox.prop('checked');

    var filterColumn = _(cls._columnData).filter(function (data) {
      // 非表示定義列
      if (data.columnType === 'hidden') return false;
      // 個人情報
      if (!isShowPersonalInfo && (data.columnType === 'personalInfo' || data.group === 'common1Group' || data.group === 'common2Group')) return false;
      // アンケート
      if (!isShowSurvey && (data.columnType === 'survey' || (_.startsWith(data.group, 'enquete') && _.endsWith(data.group, 'Group')))) return false;
      // 削除
      if (!isShowDelete && data.checked && !cls._isFixedColumnType(data.columnType)) return false;
      return true;
    }).map(function (data) {
      return data.field;
    }).value();

    // スクロールをリセット
    // TODO: ここでリセットしないとスクロール範囲外がカレントになってしまうことがある
    w2ui[GRID_ID].last.scrollTop = 0;
    w2ui[GRID_ID].last.scrollLeft = 0;

    w2ui[GRID_ID].hideColumn(...cls._columnData.map(data => data.field));
    w2ui[GRID_ID].showColumn(...filterColumn);
  }

  /**
   * フィルタ機能(列)の初期化
   */
  _initFilterColumn() {
    const cls = this;

    // フィルターチェックボックス
    cls.$filterColumnCheckBox.on('change', function () {
      // カスタムフィルタの適用
      cls.customColumnFilter();
    });
  }

  /**
   * フィルタ機能(行)の初期化
   */
  _initFilterRecord() {
    const cls = this;

    // 行のカスタムフィルタを適用
    const customFilter = () => {
      // マスク検索の条件
      const filterdMask = {
        isShowSubmission      : cls.$filterSubmissionCheckBox.prop('checked'),
        isShowMaskSubmission  : cls.$filterMaskSubmissionCheckBox.prop('checked'),
        isShowDelete          : cls.$filterDeleteCheckBox.prop('checked'),
        isShowStatusStop      : cls.$filterStatusStopCheckBox.prop('checked'),
        isShowStatusLead      : cls.$filterStatusLeadCheckBox.prop('checked'),
        isShowReasonDishonest : cls.$filterReasonDishonestCheckBox.prop('checked')
      };

      // 閲覧コンテンツの条件
      // チェックボックスONのfield名を求める
      const filterdContentList = _.map(cls.$SearchContentListWrap.find('input:checked'), item => {
        return $(item).attr('name')
      });

      // フィルター結果を求める
      const filterdField = _(w2ui[GRID_ID].records)
        .filter(record => {
          // 提出済
          if (!filterdMask.isShowSubmission && record.submission === '済') return false;
          // マスク提出済
          if (!filterdMask.isShowMaskSubmission && record.mask === '済') return false;
          // 削除済
          if (!filterdMask.isShowDelete && record[FIELD_INIT_DELETE] === true) return false;
          // 会員ステータス（凍結・停止会員）
          if (!filterdMask.isShowStatusStop
            && (record.memberstatus.indexOf('凍結') > -1 && record.memberstatus.indexOf('停止') > -1 )
          ) return false;
          // 会員ステータス（リードBL）
          if (!filterdMask.isShowStatusLead && record.memberstatus === 'リードBL') return false;
          // 会員情報不十分（不誠実入力）
          if (!filterdMask.isShowReasonDishonest && record.reason === '不誠実入力') return false;
          // 閲覧コンテンツ
          const hasContent = _.some(filterdContentList, field => record[field] !== true);
          if (hasContent) return false;

          return true;
        })
        .map(record => record.recid - 1)
        .value();

      w2ui[GRID_ID].searchData = _.filter(w2ui[GRID_ID].searchData, (item) => item.type !== CUSTOM_FILTER_LABEL);
      w2ui[GRID_ID].localSearch();

      const currentIds = w2ui[GRID_ID].last.searchIds;
      const currentCondition = w2ui[GRID_ID].searchData;

      if (w2ui[GRID_ID].searchData.length === 0) {
        w2ui[GRID_ID].last.searchIds = filterdField;
      } else {
        w2ui[GRID_ID].last.searchIds = _.intersection(filterdField, currentIds);
      }

      w2ui[GRID_ID].searchData = currentCondition.concat([{
        type: CUSTOM_FILTER_LABEL,
        filterdMask,
        filterdContentList
      }]);

      w2ui[GRID_ID].refresh();
    }

    // フィルター条件を取得
    const getFormFilterCondition = () => {
      const inputs = this.$filterRecordForm.find('input.has-val, select.has-val');

      return _.map(inputs, item => {
        const operator = item.getAttribute('data-operator') || 'contains';

        return {
          field : item.name,
          value : item.value,
          type  : 'text', operator
        };
      })
    };

    // フィルター条件のリセット
    const resetFormFilterCondition = () => {
      const inputs = this.$filterRecordForm.find('input.has-val, select.has-val');

      _.forEach(inputs, item => {
        const $item = $(item);

        $item.val('');
        $item.removeClass('has-val');
      });

      cls.$filterSubmissionCheckBox.prop('checked', true);
      cls.$filterMaskSubmissionCheckBox.prop('checked', true);
      cls.$filterDeleteCheckBox.prop('checked', true);
      cls.$filterStatusStopCheckBox.prop('checked', true);
      cls.$filterStatusLeadCheckBox.prop('checked', true);
      cls.$filterReasonDishonestCheckBox.prop('checked', true);
      cls.$SearchContentListWrap.find('input').prop('checked', false);
    };

    // フィルター条件の復元
    const restoreFilterCondition = () => {
      // 一旦全てリセット
      resetFormFilterCondition();

      // 現状適用されているフィルタ条件を反映
      w2ui[GRID_ID].searchData.forEach(filter => {
        if (filter.type === CUSTOM_FILTER_LABEL) {
          // カスタムフィルタ(チェックボックス)
          // 表示エリア
          if (filter.filterdMask) {
            const currentFilter = filter.filterdMask;

            cls.$filterSubmissionCheckBox.prop('checked', currentFilter.isShowSubmission);
            cls.$filterMaskSubmissionCheckBox.prop('checked', currentFilter.isShowMaskSubmission);
            cls.$filterDeleteCheckBox.prop('checked', currentFilter.isShowDelete);
            cls.$filterStatusStopCheckBox.prop('checked', currentFilter.isShowStatusStop);
            cls.$filterStatusLeadCheckBox.prop('checked', currentFilter.isShowStatusLead);
            cls.$filterReasonDishonestCheckBox.prop('checked', currentFilter.isShowReasonDishonest);
          }
          // 閲覧コンテンツ
          if (filter.filterdContentList.length) {
            filter.filterdContentList.forEach(name => {
              cls.$SearchContentListWrap.find(`[name=${name}]`).prop('checked', true);
            })
          }
        } else {
          // フォーム系
          const $form = cls.$filterRecordForm.find(`[name=${filter.field}]`);

          $form.val(filter.value);
          $form.addClass('has-val');
        }
      });
    };

    // 検索を開くボタン
    cls.$SearchOpenButton.on('click', function() {
      restoreFilterCondition();
    });

    // 検索ボタン
    cls.$SearchExecuteButton.on('click', function () {
      // 検索
      w2ui[GRID_ID].last.logic = "AND";
      w2ui[GRID_ID].searchData = getFormFilterCondition(); //[{ field: "fname", type: "text", operator: "is", value: "鈴木" }];
      w2ui[GRID_ID].localSearch();
      // カスタムフィルタの適用
      customFilter();
    });

    // リセットボタン
    cls.$SearchResetButton.on('click', function () {
      resetFormFilterCondition();

      // 検索の初期化
      // w2ui[GRID_ID].searchReset();
    });
  }

  /**
   * エラーメッセージの表示
   * @param {*} errorMessage
   */
  _showError(errorMessage) {
    this.$errorMessage.text(errorMessage);
    this.$error.show();
  }

  /**
   * エラーメッセージを非表示
   */
  _dismissError() {
    this.$error.hide();
  }

  /**
   * 固定列かを判別
   * @param {*} columnType
   */
  _isFixedColumnType(columnType) {
    const cls =  this;
    const fixedColumnData = (cls._gridType === "seminor") ? FIXED_COLUMN_DATA_SEMINOR : FIXED_COLUMN_DATA;
    if (!cls._enableAttendStatus) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'clientStatus'; });
    }
    if (!cls._enableAttend) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'attend'; });
    }
    if (!cls._enableSendRequest) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'sendRequest'; });
    }
    return fixedColumnData.some(item => item.columnType === columnType);
  }

  /**
   * 固定列を除いた列のインデックスを返却
   * @param {*} field
   */
  _getColumnIndex(field) {
    const cls = this;

    return _(cls._columnData).filter(data => !cls._isFixedColumnType(data.columnType))
                             .findIndex(data => data.field === field) + 1;
  }

  /**
   * 各列の描画
   * @param {*} column
   * @param {boolean} isInitialize 初期化時はtrue
   */
  _renderColumn(column, isInitialze = false) {
    const cls = this;

    const columnIndex = cls._getColumnIndex(column.field);
    const group = _.find(cls._columnGroupData, data => data.id === column.group);
    const groupColor = _.get(group, 'color', null);

    switch (column.columnType) {
      // 提出
      case 'submission': {
        return {
          field: column.field,
          caption: cls._genHeaderArea(cls._genCellCheckBox(column.checked, '提<br>出'), groupColor),
          tooltip: '提出',
          size: '44px',
          frozen: true,
          render: function(rcd, idx, col_idx) {
            if (!cls._enableSendRequest && typeof rcd.submission === 'boolean')
            {
              return '';
            }
            return cls._genCellCheckOrTxt(rcd.submission);
          }
        };
      }
      // 情報開示
      case 'sendRequest': {
        return {
          field: column.field,
          caption: cls._genHeaderArea(cls._genCellCheckBox(column.checked, '情報<br>開示'), groupColor),
          tooltip: '情報開示',
          size: '70px',
          frozen: true,
          render: function(rcd, idx, col_idx) {
            if (!cls._enableSendRequest && typeof rcd.sendRequest === 'boolean')
            {
              return '';
            }
            return cls._genCellCheckOrTxt(rcd.sendRequest);
          }
        };
      }
      // 削除
      case 'delete': {
        return {
          field: column.field,
          caption: cls._genHeaderArea(cls._genCellCheckBox(column.checked, '削<br>除'), groupColor),
          tooltip: '削除',
          size: '48px',
          frozen: true,
          render: function(rcd, idx, col_idx) {
            var div = '<div' + (rcd.deleteRequest ? ' class="is-delete-request" title="クライアントより削除依頼が来ています"' : '') + '>';
            return div + cls._genCellCheckBox(rcd.delete, rcd[FIELD_INIT_DELETE] ? '済' : '') + '</div>';
          }
        };
      }
      // ステータス
      case 'status': {
        return {
          field: column.field,
          caption: cls._genHeaderArea('ステータス', groupColor),
          tooltip: 'ステータス',
          size: '100px',
          frozen: true,
          render: function(rcd, idx, col_idx) {
            return cls._genCellSelectBox(cls._gridType === 'onlinelead' ? OPTION_ONLINELEAD_STATUS : OPTION_STATUS, rcd.status, rcd.recid, column.field);
          }
        };
      }
      // 受講票
      case 'clientStatus': {
        return {
          field: column.field,
          caption: cls._genHeaderArea(cls._gridType === 'onlinelead' ? '対象' : '受講票', groupColor),
          tooltip: cls._gridType === 'onlinelead' ? '対象' : '受講票',
          size: '80px',
          frozen: true,
          render: function (rcd, idx, col_idx) {
            if (rcd.clientStatus === 'OK' || rcd.clientStatus === 'NG') {
              return rcd.clientStatus;
            }
            return cls._genCellSelectBox(OPTION_CLIENT_STATUS, rcd.clientStatus, rcd.recid, column.field);
          }
        };
      }
      // オプションフラグ
      case 'option': {
        return {
          field: column.field,
          caption: cls._genHeaderArea('オプション<br>フラグ', groupColor),
          tooltip: 'オプションフラグ',
          size: '70px',
          frozen: true
        };
      }
      // 出席
      case 'attend': {
        return {
          field: column.field,
          caption: cls._genHeaderArea('出席', groupColor),
          tooltip: '出席',
          size: '70px',
          frozen: true,
          render: function (rcd, idx, col_idx) {
            return cls._genCellCheckBox(rcd.attend, rcd.chacked);
          }
        };
      }
      // 当日受付
      case 'receipt': {
        return {
          field: column.field,
          caption: cls._genHeaderArea('当日受付', groupColor),
          tooltip: '当日受付',
          size: '70px',
          frozen: false,
          editable: true,
          render: function (rcd, idx, col_idx) {
            return cls._genCellCheckBox(rcd[column.field]);
          }
        };
      }
      // 番号
      case 'number': {
        const { field } = column;
        return {
          field: field,
          caption: cls._genHeaderArea(cls._genCellCheckBox(column.checked, '番号'), groupColor),
          tooltip: '番号',
          size: '65px',
          frozen: true,
          render: function (rcd, idx, col_idx) {
            if (rcd.clientStatus === 'OK' || rcd.clientStatus === 'NG') {
              return rcd[column.field];
            }
            return rcd[column.field] + '&nbsp;' + cls._genCellCheckBox(rcd.selected);
          }
        };
      }
      // 氏名
      case 'name': {
        const { field } = column;
        return {
          field: field,
          caption: cls._genHeaderArea('氏名', groupColor),
          tooltip: '氏名',
          size: '140px',
          frozen: true,
          render: function render(rcd, idx, col_idx) {
            return `<a class="c-lst_link" href="javascript:void(0)" data-lead-list-row-id="${rcd.leadListRowId}">${rcd.name}</a>`;
          }
        };
      }
      // 会員タイプ
      case 'role': {
        const { field } = column;
        return {
          field: field,
          caption: cls._genHeaderArea('会員タイプ', groupColor),
          tooltip: '会員タイプ',
          size: '70px',
          frozen: true,
        };
      }
      // 備考
      case 'attendremark': {
        const { field } = column;
        return {
          field: field,
          caption: cls._genHeaderArea('備考', groupColor),
          tooltip: '備考',
          size: '120px',
          frozen: true,
        };
      }
      // 受講番号
      case 'attendnum': {
        const { field } = column;
        return {
          field: field,
          caption: cls._genHeaderArea('受講番号', groupColor),
          tooltip: '受講番号',
          size: '120px',
          frozen: true,
        };
      }
      // 非表示列
      case 'hidden': {
        const { field } = column;
        return {
          field: field,
          size: '120px',
          hidden: true,
          frozen: true,
        };
      }
      // コンテンツ情報
      case 'contentInfo': {
        const { label, field, checked, hideAllCheck } = column;
        var _number = (column.number > 0) ? column.number : '';
        return {
          field: field,
          attr: (column.checked) ? 'checked' : '',
          caption: cls._genHeaderArea(`<span class="c-grid_check_num">${_number}</span>${label}`, groupColor),
          tooltip: label,
          size: '120px',
          render: function (rcd, idx, col_idx) {
            return (rcd[field]) ? '◯' : '';
          }
        };
      }
      // セッション
      case 'session': {
        var _label4 = column.label,
            _field9 = column.field,
            _checked4 = column.checked,
            _hideAllCheck2 = column.hideAllCheck;
        var _number = (column.number > 0) ? column.number : '';
        return {
            field: _field9,
            attr: column.checked ? 'checked' : '',
            caption: cls._genHeaderArea("<span class=\"c-grid_check_num\">" + _number + "</span>" + _label4, groupColor),
            tooltip: _label4,
            size: '120px',
            render: function render(rcd, idx, col_idx) {
                return rcd[_field9] ? '●' : '';
            }
        };
      }
      // カスタム
      case 'custom': {
        const { label, field, checked } = column;
        var _number = (column.number > 0) ? column.number : '';
        const attr = [];
        if (column.checked) attr.push('checked');
        return {
          field,
          attr: attr.join(' '),
          caption: cls._genHeaderArea(`<span class="c-grid_check_num is-${column.columnType}">${_number}</span>${label}`, groupColor),
          tooltip: label,
          size: '100px',
          editable: (cls._editable)? { type: 'text' } : null
        };
      }
      // 閲覧日時
      case 'viewdate': {
        const { label, field, checked } = column;
        var _number = (column.number > 0) ? column.number : '';
        const editable = (column.columnType !== 'viewdate' && cls._editable) ? { type: 'text' } : null;
        const attr = [];
        if (column.checked) attr.push('checked');
        if (_.includes(this._maskedColumn, field)) attr.push('masked');
        return {
          field,
          attr: attr.join(' '),
          caption: cls._genHeaderArea(`<span class="c-grid_check_num is-${column.columnType}">${_number}</span>${label}`, groupColor),
          tooltip: label,
          size: '140px',
          editable
        };
      }
      // チェックボックス
      case 'checkbox': {
        var _label5 = column.label,
            _field10 = column.field,
            _checked5 = column.checked,
            _hideAllCheck3 = column.hideAllCheck;
        var _number = (column.number > 0) ? column.number : '';
        var _attr3 = [];
        var _caption2 = _hideAllCheck3 ? cls._genHeaderArea("<span class=\"c-grid_check_num\">" + _number + "</span>" + _label5, groupColor) : cls._genHeaderArea(cls._genCellCheckBox(_checked5, "<span class=\"c-grid_check_num\">" + _number + "</span>" + _label5, "is-" + column.columnType + " " + (_checked5 ? 'is-delete' : '')), groupColor);
        if (column.number <= 0) { // 特典列( < 0 )はピリオドも不要な為、クラス解除
            _caption2 = _caption2.replace('c-grid_check_num', '')
        }
        if (column.checked) _attr3.push('checked');
        if (_.includes(this._maskedColumn, _field10)) _attr3.push('masked');
        return {
          field: _field10,
          attr: _attr3.join(' '),
          caption: _caption2,
          tooltip: _label5,
          size: '100px',
          editable: cls._editable ? { type: 'text' } : null,
          render: function render(rcd, idx, col_idx) {
            return rcd[_field10] ? '●' : '';
          }
        };
      }
      // 個人情報
      case 'personalInfo':
      // コンテンツ情報テキスト
      case 'contentInfoText':
      // アンケート
      case 'survey':
      // その他
      default: {
        const { label, field, checked, hideAllCheck } = column;
        var _number = (column.number > 0) ? column.number : '';
        const editable = (column.columnType !== 'viewdate' && cls._editable)? { type: 'text' } : null;
        const attr = [];
        var caption = (hideAllCheck) ? cls._genHeaderArea(`<span class="c-grid_check_num">${_number}</span>${label}`, groupColor) : cls._genHeaderArea(cls._genCellCheckBox(checked, `<span class="c-grid_check_num">${_number}</span>${label}`, `is-${column.columnType} ${(checked) ? 'is-delete' : ''}`), groupColor);
        if (column.number <= 0) { // 特典列( < 0 )はピリオドも不要な為、クラス解除
            caption = caption.replace('c-grid_check_num', '')
        }
        if (column.checked) attr.push('checked');
        if (_.includes(this._maskedColumn, field)) attr.push('masked');
        return {
          field,
          attr: attr.join(' '),
          caption,
          tooltip: label,
          size: '100px',
          editable
        };
      }
    }
  }

  /**
   * 各行の描画
   * TODO: w2ui.styleにbackground-colorを指定すると、行選択時に上書きされるので指定しないこと
   * @param {*} rcd
   * @param {boolean} isInitialize 初期化時はtrue
   */
  _renderRecord(rcd, isInitialze = false) {
    const cls = this;
    const className = [];

    if (!rcd.hasOwnProperty('w2ui')) {
      rcd.w2ui = { class: '' };
    }

    // 未操作行
    if (rcd.untreated) {
      className.push('is-operatable');
    }

    // 削除行
    if (rcd.delete) {
      className.push('is-delete');
    }

    // 初期化時の削除フラグを別パラメタとして保持する
    if (isInitialze) {
      rcd[FIELD_INIT_DELETE] = rcd.delete;
    }

    // マスク
    if (rcd.isMasked) {
      className.push('is-mask');
    };

    rcd.w2ui.class = className.join(' ');

    return rcd;
  }

  /**
   * リードレコードテーブルの初期化
   * @param {*} rcdHead 列ヘッダオプション
   * @param {*} rcdGroups 列ヘッダのグループ
   * @param {*} rcdRow 行データ
   * @param {*} rcdColumn 列データ(固定列を除く)
   * @param {*} orderType 案件種別(1:オンラインリード、2 or 3:セミナー)
   * @param {*} enableClientStatus 受講票列が有効かどうか
   * @param {*} enableAttend 出席列が有効かどうか
   * @param {*} enableSendRequest 情報開示リクエストの操作が有効かどうか
   */
  initDashboardReadRecordGrid(rcdHead, rcdGroups, rcdRow, rcdColumn, orderType, enableClientStatus, enableAttend, enableSendRequest) {

    // 既に定義済みであれば削除する
    if (w2ui[GRID_ID] !== undefined) {
      w2ui[GRID_ID].destroy();
    }

    const cls = this;
    const $tgt = $('.js-grid_dashboard_readrecord');
    if (!cls._initHeight) {
      cls._initHeight = $tgt.height();
    }
    else {
      $tgt.height(cls._initHeight);
    }

    cls._gridType = "readrecord"; // 初期値
    if (orderType == 1) {
      cls._gridType = "onlinelead";
    }
    else if (orderType == 2 || orderType == 3) {
      cls._gridType = "seminor";
    }
    else if (orderType == 98) {
      cls._gridType = "research";
    }
    else if (orderType == 99) {
      cls._gridType = "campaign";
    }
    cls._enableAttendStatus = !!enableClientStatus;
    cls._enableAttend = !!enableAttend;
    cls._enableSendRequest = enableSendRequest;

    // 列の番号からフィールド名を取得
    const getFieldFromColumnIndex = (columnIndex) => w2ui[GRID_ID].columns[columnIndex].field;

    // 列の番号からカラムタイプを取得
    const getColumnTypeFromColumnIndex = (columnIndex) => cls._columnData[columnIndex].columnType;

    // セルの値を変更
    // (行のスタイルに影響がある場合を考慮し、行全体の更新も行なっています。通常のsetterより動作が重いので、使う箇所は検討した上で使用してください)
    const setCellValue = (recid, value) => {
      const record = w2ui[GRID_ID].get(recid);

      w2ui[GRID_ID].set( recid, this._renderRecord(Object.assign(record, value)), false );
      // refreshRowがスキップされることがあり、不安定なのでrefreshを使用しています
      // w2ui[GRID_ID].refreshRow(recid);
      w2ui[GRID_ID].refresh();
    };

    let fixedColumnData = (cls._gridType === "seminor") ? FIXED_COLUMN_DATA_SEMINOR : FIXED_COLUMN_DATA;
    if (!cls._enableAttendStatus) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'clientStatus'; });
    }
    if (!cls._enableAttend) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'attend'; });
    }
    if (!cls._enableSendRequest) {
      _.remove(fixedColumnData, function (e) { return e.columnType === 'sendRequest'; });
    }

    // 列データの初期化
    cls._columnData = _.concat(fixedColumnData, _.map(rcdColumn, column => {
      column.checked = _.includes(rcdHead.del_clm, column.field);
      return column;
    }));

    cls._maskedColumn = rcdHead.mask_clm || [];
    cls._columnGroupData = INIT_GROUPS.concat(rcdGroups);
    cls._editable = rcdHead.editable || false;

    // 検索エリアにコンテンツ情報のチェックボックスを追加
    const contentInfoList = _.filter(rcdColumn, item => item.columnType === 'contentInfo');

    cls.$SearchContentListWrap.empty();
    contentInfoList.forEach(item => {
      const $SearchContentList = cls.$SearchContentList.clone();

      $SearchContentList.find('span').text(item.label);
      $SearchContentList.find('input').attr('name', item.field);
      $SearchContentList.appendTo(cls.$SearchContentListWrap);
    });

    // 20行未満は高さ変動
    var fixedheight = false;
    if (rcdRow.length > 20) {
      fixedheight = true;
    }

    // データヘッダーの定義
    $tgt.w2grid({
      disableCVS: false, // スクロール時の動的なDOM生成をしないか(レコードが少ないときはtrueの方が早い)
      name: GRID_ID,
      fixedBody: fixedheight,
      recordHeight: 26,
      columns: this._columnData.map(item => this._renderColumn(item, true)),
      records: rcdRow.map(item => this._renderRecord(item, true)),
      show: {
        toorbar        : true,
        toolbarReload  : false,   // ツールバーに「reload」ボタンを表示するかどうか
        toolbarColumns : false,   // ツールバーに「columns(|||)」ボタンを表示するかどうか
        toolbarSearch  : true,    // ツールバーに検索ボックスを表示するかどうか
        toolbarAdd     : false,   // ツールバーに「Add New」ボタンを表示するかどうか
        toolbarEdit    : false,   // ツールバーに「Edit」ボタンを表示するかどうか
        toolbarDelete  : false,   // ツールバーに「Delete」ボタンを表示するかどうか
        toolbarSave    : false,   // ツールバーに「Save」ボタンを表示するかどうか
      },
      keyboard: false,
      // セルタップ時のイベント
      onClick: function(event) {
        const { recid, column } = event;
        const field = getFieldFromColumnIndex(column);
        const columnType = getColumnTypeFromColumnIndex(column);

        const resetColumn = (column) => {
          cls._columnData[column].checked = false;
          w2ui[GRID_ID].columns[column] = Object.assign(column, cls._renderColumn(cls._columnData[column]));
        };

        if (columnType === 'receipt') {
          const receiptValue = w2ui[GRID_ID].getCellValue(recid - 1, column);
          if (typeof receiptValue === 'boolean') {
            if (receiptValue) {
              resetColumn(column);
            }
            setCellValue(recid, { [field] : !receiptValue });
          }
          return;
        }

        switch (field) {
          // 提出
          case 'submission': {
            if (!cls._enableSendRequest)
            {
              break;
            }
            const submissionValue = w2ui[GRID_ID].getCellValue(recid - 1, column);
            if (typeof submissionValue === 'boolean') {
              if (submissionValue) {
                resetColumn(column);
              }
              setCellValue(recid, { submission: !submissionValue });
            }
            break;
          }
          // 情報開示
          case 'sendRequest': {
            if (!cls._enableSendRequest)
            {
              break;
            }
            const sendRequestValue = w2ui[GRID_ID].getCellValue(recid - 1, column);
            if (typeof sendRequestValue === 'boolean') {
              if (sendRequestValue) {
                resetColumn(column);
              }
              setCellValue(recid, { sendRequest: !sendRequestValue });
            }
            break;
          }
          // 出席
          case 'attend': {
            const attendValue = w2ui[GRID_ID].getCellValue(recid - 1, column);
            if (typeof attendValue === 'boolean') {
              if (attendValue) {
                resetColumn(column);
              }
              setCellValue(recid, { attend: !attendValue });
            }
            break;
          }
          // 削除
          case 'delete': {
            const deleteValue = w2ui[GRID_ID].getCellValue(recid - 1, column);
            if (deleteValue) {
              resetColumn(column);
            }
            setCellValue(recid, { delete: !deleteValue });
            break;
          }
          // 番号
          case 'num': {
            const selectedValue = w2ui[GRID_ID].records[recid - 1].selected || false;
            if (selectedValue) {
              resetColumn(column);
            }
            setCellValue(recid, { selected: !selectedValue });
            break;
          }
          default:
            break;
        }
      },
      // カラムヘッダータップ時のイベント
      onColumnClick: function(event) {
        const { field } = event;
        // カラム情報
        const column = w2ui[GRID_ID].getColumn(field);
        // カラムのタイプ
        const columnType = _.find(cls._columnData, column => column.field === field).columnType;
        // カラム番号
        const columnIndex = _.findIndex(cls._columnData, column => column.field === field);

        // 現在表示されているレコードのid
        const currentShowIndex = (w2ui[GRID_ID].last.searchIds.length) ? w2ui[GRID_ID].last.searchIds : _.range(w2ui[GRID_ID].records.length);

        // カラム内の要素タップ時のみに反応させる
        if(event.originalEvent.target.nodeName.toLowerCase() !== 'span') return;

        switch (columnType) {
          // 提出
          case 'submission': {
            if (!cls._enableSendRequest)
            {
              break;
            }
            // 元データを更新
            cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // カラムの情報を更新
            w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // レコードの情報を更新
            _.forEach(currentShowIndex, index => {
              const record = w2ui[GRID_ID].records[index];
              if (typeof record.submission === 'boolean') record.submission = cls._columnData[columnIndex].checked;
            });
            // w2uiのリフレッシュ
            w2ui[GRID_ID].refresh();
            break;
          }
          // 情報開示
          case 'sendRequest': {
            if (!cls._enableSendRequest)
            {
              break;
            }
            // 元データを更新
            cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // カラムの情報を更新
            w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // レコードの情報を更新
            _.forEach(currentShowIndex, index => {
              const record = w2ui[GRID_ID].records[index];
              if (typeof record.sendRequest === 'boolean') record.sendRequest = cls._columnData[columnIndex].checked;
            });
            // w2uiのリフレッシュ
            w2ui[GRID_ID].refresh();
            break;
          }
          // 出席
          case 'attend': {
            // // 元データを更新
            // cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // // カラムの情報を更新
            // w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // // レコードの情報を更新
            // _.forEach(currentShowIndex, index => {
            //   const record = w2ui[GRID_ID].records[index];
            //   if (typeof record.attend === 'boolean') record.attend = cls._columnData[columnIndex].checked;
            // });
            // // w2uiのリフレッシュ
            // w2ui[GRID_ID].refresh();
            break;
          }
          // 削除
          case 'delete': {
            // 元データを更新
            cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // カラムの情報を更新
            w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // レコードの情報を更新
            _.forEach(currentShowIndex, index => {
              let record = w2ui[GRID_ID].records[index];
              record.delete = cls._columnData[columnIndex].checked;
              record = cls._renderRecord(record);
            });
            // w2uiのリフレッシュ
            w2ui[GRID_ID].refresh();
            break;
          }
          // 番号
          case 'number': {
            // 元データを更新
            cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // カラムの情報を更新
            w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // レコードの情報を更新
            _.forEach(currentShowIndex, index => {
              const record = w2ui[GRID_ID].records[index];
              record.selected = cls._columnData[columnIndex].checked;
            });
            // w2uiのリフレッシュ
            w2ui[GRID_ID].refresh();
            break;
          }
          // 備考
          case 'attendremark':
          // 受講番号
          case 'attendnum':
          // 閲覧情報
          case 'viewdate':
          // コンテンツ情報
          case 'contentInfo':
          // コンテンツ情報
          case 'contentInfoText':
          // 個人情報
          case 'personalInfo':
          // アンケート
          case 'survey':
          // カスタム
          case 'custom':
          // チェックボックス
          case 'checkbox':
          // セル情報は全てこれにしている
          case 'text': {
            // // 元データを更新
            // cls._columnData[columnIndex].checked = !cls._columnData[columnIndex].checked;
            // // カラムの情報を更新
            // w2ui[GRID_ID].columns[columnIndex] = Object.assign(column, cls._renderColumn(cls._columnData[columnIndex]));
            // // w2uiのリフレッシュ
            // w2ui[GRID_ID].refresh();
            break;
          }
          // ステータス
          case 'status':
          // オプション
          case 'option':
          // その他
          default: {
            break;
          }
        }
      },
      onChange: function(event) {
        if (cls._columnData[event.column].columnType === 'checkbox') {
          // 1 or nullのみ許可
          var val = $('#' + event.input_id).val() + '';
          if (val !== '1' && val !== '') {
            event.preventDefault();
          }
        }

        event.onComplete = function () {
          const editRecord = w2ui[GRID_ID].getChanges();

          w2ui[GRID_ID].mergeChanges();

          editRecord.forEach(record => {
            const recid = record.recid || 0;
            w2ui[GRID_ID].refreshRow(recid);
          });
        };
      }
    });

    $tgt.on('change', 'select', function (event) {
      const $target = $(event.target);
      const value = $target.val();
      const recid = $target.data('recid');
      const field = $target.data('field');
      if (recid !== null && field !== null) {
        setCellValue(recid, { [field] : value })
      }
    });

    // 列のフィルター適用
    cls.customColumnFilter();
  }

  /**
   * 情報開示リクエストをするレコードを取得
   */
  findSendRequestRecords() {
    if (!w2ui[GRID_ID]) {
      return [];
    }

    return _.filter(w2ui[GRID_ID].records, (rcd) => typeof rcd.sendRequest === 'boolean' && rcd.sendRequest);
  }

  setupStatusAllSetter() {
    const cls = this
    for (let i = 0; i < OPTION_CLIENT_STATUS.length; i++) {
      $('<option/>', OPTION_CLIENT_STATUS[i]).appendTo(cls.$allSetterSelector)
    }

    cls.$allSetterTrigger.on('click', () => {
      if (!w2ui[GRID_ID]) {
        return
      }

      const value = cls.$allSetterSelector.val()
      const length = w2ui[GRID_ID].records.length
      for (let i = 0; i < length; i++) {
        if (w2ui[GRID_ID].records[i].clientStatus === 'OK' || w2ui[GRID_ID].records[i].clientStatus === 'NG' || !w2ui[GRID_ID].records[i].selected) {
          continue;
        }

        w2ui[GRID_ID].records[i].clientStatus = value
      }

      w2ui[GRID_ID].refresh();
    })
  }
}